import { createFileRoute } from "@tanstack/react-router";
import { HomePage } from "@/components/home/HomePage";
import { homeHead } from "@/components/home/home-head";
import { loadHome } from "@/components/home/home-loader";

export const Route = createFileRoute("/az/")({
  // Число стран для пина «за рубежом» и ссылки «Populyar» (29.10.2026). Сбой любой части — без неё.
  loader: () => loadHome("az"),
  head: () => homeHead("az"),
  component: function Page() {
    const data = Route.useLoaderData();
    return <HomePage lang="az" countries={data.countries} popular={data.popular} />;
  },
});
